// tslint:disable-next-line:no-shadowed-variable
import {ConfigModel} from '../core/interfaces/config';

// tslint:disable-next-line:no-shadowed-variable

// Combined count for the Work Queues group, so the badges still show while it is collapsed
function workQueueCount(): number {
    return ['stageCount', 'partsExpiringCount', 'partExpiredCount'].reduce(function(total, key) {
        return total + (parseInt(localStorage.getItem(key), 10) || 0);
    }, 0);
}

export class MenuConfig implements ConfigModel {
    public config: any = {};

    constructor() {
        this.config = {
            header: {
                self: {},
                items: [
                    // Header menu default working is overwritten - hence this value is no more required
                    // {
                    //     title: 'Admin Dashboard'
                    // }
                ]
            },
            aside: {
                self: {},
                items: [
                    {
                        title: 'Dashboard',
                        desc: 'Admin Dashboard',
                        root: true,
                        icon: 'fas fa-tachometer-alt',
                        page: '/dashboard-v2',

                    },
                    {
                        title: 'Company',
                        desc: 'Users listing, details and action',
                        root: true,
                        icon: 'fas fa-building',
                        page: '/manage-company',
                        staffAllowed: true,

                    },
                    {
                        title: 'Manage Sites ',
                        desc: 'Users listing, details and action',
                        root: true,
                        icon: 'fa fa-building',
                        page: '/manage-site',
                    },
                    {
                        title: 'User Management',
                        desc: 'Users listing, details and action',
                        root: true,
                        icon: 'fa fa-user',
                        page: '/manage-user',
                    },
                    {
                        title: 'AED',
                        desc: 'AED listing, details and action',
                         root: false,
                        icon: 'fa fa-heartbeat',
                        page: '/manage-aed',
                    },
                    {
                        title: 'Equipment',
                        desc: 'Non-AED equipment listing and actions',
                        root: false,
                        icon: 'fa fa-briefcase-medical',
                        page: '/manage-equipment',
                    },
                    {
                        title: 'Plans',
                        desc: 'Plan Management',
                        root: true,
                        icon: 'fas fa-shopping-bag',
                        page: '/subscription-list',
                    },
                    {
                        title: 'Reseller Dashboard',
                        desc: 'Reseller Dashboard',
                        root: true,
                        icon: 'fas fa-chart-line',
                        page: '/reseller-dashboard',

                    },
                    {
                        section: 'Manage',
                    },
                    {
                        title: 'Work Queues',
                        desc: 'Requests and part expiries waiting on action',
                        root: true,
                        icon: 'fas fa-inbox',
                        value: workQueueCount(),
                        submenu: [
                            {
                                title: 'AED Requests',
                                desc: 'Users listing, details and action',
                                icon: 'fa fa-random',
                                page: '/aed-request',
                            },
                            {
                                title: 'Remove AED Request',
                                desc: 'Users listing, details and action',
                                icon: 'fas fa-user-minus',
                                page: '/manage-remove-aed-request',
                            },
                            {
                                title: 'Staging Area',
                                desc: 'Accessory replacement request list, details and action',
                                icon: 'fas fa-sync',
                                page: '/accessory-replacement-request',
                                value: localStorage.getItem('stageCount'),
                            },
                            {
                                title: 'Parts Expiring Soon',
                                desc: 'Parts Expiring',
                                icon: 'fas fa-battery-quarter',
                                page: '/parts-expiring',
                                value: localStorage.getItem('partsExpiringCount'),
                            },
                            {
                                title: 'Parts Expired',
                                desc: 'Parts Expired',
                                icon: 'fas fa-calendar-times',
                                page: '/parts-expired',
                                value: localStorage.getItem('partExpiredCount'),
                            },
                        ]
                    },
                    {
                        title: 'Field Activity',
                        desc: 'Inspections, incidents, inspectors and responders',
                        root: true,
                        icon: 'fas fa-first-aid',
                        submenu: [
                            {
                                title: 'Inspections',
                                desc: 'Inspections',
                                icon: 'fas fa-search',
                                page: '/inspection',
                            },
                            {
                                title: 'Incidents',
                                desc: 'Incidents',
                                icon: 'far fa-calendar-alt',
                                page: '/incidents',
                            },
                            {
                                title: 'Global Inspector',
                                desc: 'Global Inspector listing, details and action',
                                icon: 'fa fa-user',
                                page: '/manage-global-inspector',
                            },
                            {
                                title: 'Responder',
                                desc: 'Users listing, details and action',
                                icon: 'fas fa-reply',
                                page: '/manage-responder',
                            },
                        ]
                    },
                    {
                        title: 'Reports',
                        desc: 'Reports',
                        root: true,
                        icon: 'fas fa-chart-pie',
                        submenu: [
                            {
                                title: 'Reports',
                                desc: 'Reports',
                                icon: 'fas fa-file-alt',
                                page: '/reports',
                            },
                            {
                                title: 'Account Stats',
                                desc: 'Reseller and state distribution of accounts',
                                icon: 'fas fa-chart-bar',
                                page: '/account-stats',
                            },
                            {
                                title: 'Removed Company AEDs',
                                desc: 'AEDs still on companies that have been removed',
                                icon: 'fas fa-building',
                                page: '/removed-company-aeds',
                            },
                            {
                                title: 'Manage Renew Report',
                                desc: 'Manage Renew Report',
                                icon: 'fas fa-file-alt',
                                page: '/manage-renew-report',
                            },
                            {
                                title: 'Tag Battery Report',
                                desc: 'Tags due for new cells, and the accounts they sit at',
                                icon: 'fas fa-battery-quarter',
                                page: '/tag-battery-report',
                            },
                            {
                                title: 'ZOLL Battery Report',
                                desc: 'ZOLL AED 3 batteries running down, and the accounts they sit at',
                                icon: 'fas fa-battery-quarter',
                                page: '/zoll-battery-report',
                            },
                        ]
                    },
                    {
                        title: 'Resellers & Plans',
                        desc: 'Resellers and the plan catalogs',
                        root: true,
                        icon: 'fas fa-handshake',
                        submenu: [
                            {
                                title: 'Manage Resellers',
                                desc: 'Reseller listing and management',
                                icon: 'fas fa-id-badge',
                                page: '/resellers',
                            },
                            {
                                title: 'Reseller Plans',
                                desc: 'Reseller Plans',
                                icon: 'fas fa-plus-circle',
                                page: '/reseller-subscriptions',
                            },
                            {
                                title: 'Manage Plans',
                                desc: 'Manage Plans',
                                icon: 'fas fa-clipboard-list',
                                page: '/manage-subscriptions',
                            },
                        ]
                    },
                    {
                        title: 'People & Access',
                        desc: 'Admin, support and staff accounts',
                        root: true,
                        icon: 'fas fa-user-shield',
                        submenu: [
                            {
                                title: 'Admin User',
                                desc: 'Users listing, details and action',
                                icon: 'fas fa-user',
                                page: '/manage-admin-users',
                            },
                            {
                                title: 'Support Users',
                                desc: 'Support Users listing and management',
                                icon: 'fas fa-users',
                                page: '/support-users',
                            },
                            {
                                title: 'User Restore',
                                desc: 'User Restore',
                                icon: 'fa fa-user-plus',
                                page: '/user-restore',
                            },
                            {
                                title: 'Staff Management',
                                desc: 'Manage staff members and assignments',
                                icon: 'fas fa-users',
                                page: '/staff',
                                staffRestricted: true,
                            },
                            {
                                title: 'Territory Management',
                                desc: 'Manage territories and bulk assignments',
                                icon: 'fas fa-map',
                                page: '/territories',
                                staffRestricted: true,
                            },
                        ]
                    },
                    {
                        title: 'Devices & Integrations',
                        desc: 'Trackers and connected AEDs',
                        root: true,
                        icon: 'fas fa-microchip',
                        submenu: [
                            {
                                title: 'GPS Trackers',
                                desc: 'GPS Tracker device management',
                                icon: 'fas fa-map-marker-alt',
                                page: '/gps-trackers',
                            },
                            {
                                title: 'ZOLL AED 3 Registration',
                                desc: 'Register ZOLL AED 3s for remote monitoring and see which are reporting',
                                icon: 'fas fa-wifi',
                                page: '/zoll-aed3',
                                staffRestricted: true,
                            },
                            {
                                title: 'ZOLL Sync',
                                desc: 'Trigger ZOLL API sync and view error logs',
                                icon: 'fas fa-sync-alt',
                                page: '/zoll-sync',
                            },
                        ]
                    },
                    {
                        title: 'Catalog & Content',
                        desc: 'AED makes and models, documents and templates',
                        root: true,
                        icon: 'fas fa-book',
                        submenu: [
                            {
                                title: 'Master Make',
                                desc: 'Users listing, details and action',
                                icon: 'fas fa-map-marked',
                                page: '/master-make',
                            },
                            {
                                title: 'Master Model',
                                desc: 'Users listing, details and action',
                                icon: 'fas fa-hotel',
                                page: '/master-model',
                            },
                            {
                                title: 'User Manual',
                                desc: 'User Manual',
                                icon: 'fa fa-upload',
                                page: '/user-manual-list',
                            },
                            {
                                title: 'Library',
                                desc: 'Users listing, details and action',
                                icon: 'fas fa-book-open',
                                page: '/manage-library',
                            },
                            {
                                title: 'Email Templates',
                                desc: 'Manage email notification templates',
                                icon: 'fas fa-envelope',
                                page: '/email-templates',
                            },
                        ]
                    },
                    {
                        title: 'System',
                        desc: 'Settings, queues, audits and maintenance tools',
                        root: true,
                        icon: 'fas fa-toolbox',
                        submenu: [
                            {
                                title: 'Admin Settings',
                                desc: 'System configuration and settings',
                                icon: 'fas fa-cog',
                                page: '/admin-settings',
                            },
                            {
                                title: 'Digest Queue',
                                desc: 'Monitor digest notification queue and delivery status',
                                icon: 'fas fa-envelope-open-text',
                                page: '/digest-queue',
                            },
                            {
                                title: 'AED Compliance Audit',
                                desc: 'AEDs in a state nothing on the platform will correct on its own',
                                icon: 'fas fa-clipboard-check',
                                page: '/aed-audit',
                            },
                            {
                                title: 'RX File Audit',
                                desc: 'Check and regenerate missing RX files',
                                icon: 'fas fa-file-medical',
                                page: '/rx-audit',
                            },
                            {
                                title: 'Trash Bin',
                                desc: 'AED listing, details and action',
                                icon: 'fa fa-trash',
                                page: '/trash-bin',
                            },
                            {
                                title: 'Prod to Dev Sync',
                                desc: 'Sync production data to development',
                                icon: 'fas fa-database',
                                page: '/prod-to-dev-sync',
                            },
                        ]
                    }
                    //
                    // {
                    //     title: 'Manage Notifications',
                    //     desc: 'Manage your Notifications',
                    //     root: true,
                    //     icon: 'fas fa-bell',
                    //     page: '/manage-notifications',
                    // },
                    // {
                    //     title: 'Support Tickets',
                    //     desc: 'Manage your support tickets',
                    //     root: true,
                    //     icon: 'fas fa-clipboard-list',
                    //     page: '/support-tickets',
                    // },
                ]
            }
        }
    }
}
